// eslint-disable-next-line no-unused-vars
import { Button, Tooltip, Message, Dialog } from "element-ui";
import Vue from "vue";
import "../element-variables.scss";

Vue.use(Tooltip);
Vue.use(Button);
Vue.use(Dialog);
